import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import "@react-pdf-viewer/zoom/lib/styles/index.css";
import axios from "axios";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";

function PdfViewer({ file, showDetails }) {
  const zoomPluginInstance = zoomPlugin();
  const { ZoomInButton, ZoomOutButton } = zoomPluginInstance;
  const [localFileUrl, setLocalFileUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let objectUrl = null;

    const fetchPdfBlob = async () => {
      if (!file?.fileUrl) return;

      setLoading(true);
      try {
        const response = await axios.get(file.fileUrl, {
          responseType: "blob"
        });
        const blob = new Blob([response.data], { type: "application/pdf" });
        objectUrl = URL.createObjectURL(blob);
        setLocalFileUrl(objectUrl);
      } catch (error) {
        console.error("Error fetching PDF blob:", error);
        setLocalFileUrl(file.fileUrl);
      } finally {
        setLoading(false);
      }
    };

    fetchPdfBlob();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [file?.fileUrl]);

  return (
    <Box>
      <Box sx={{ position: "relative" }}>
        <div
          style={{
            height: "70vh",
            display: loading ? "flex" : "block",
            justifyContent: "center",
            alignItems: "center"
          }}>
          {loading ? (
            <CircularProgress />
          ) : localFileUrl ? (
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
              <Viewer fileUrl={localFileUrl} plugins={[zoomPluginInstance]} />
            </Worker>
          ) : (
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}>
              <Typography>No document available</Typography>
            </Box>
          )}
        </div>
        {!loading && localFileUrl && (
          <div
            style={{
              position: "absolute",
              top: "70px",
              right: "20px",
              zIndex: 1,
              display: "flex",
              flexDirection: "column",
              gap: "10px"
            }}>
            <ZoomInButton>
              {(props) => (
                <IconButton onClick={props.onClick}>
                  <ZoomInIcon />
                </IconButton>
              )}
            </ZoomInButton>
            <ZoomOutButton>
              {(props) => (
                <IconButton onClick={props.onClick}>
                  <ZoomOutIcon />
                </IconButton>
              )}
            </ZoomOutButton>
          </div>
        )}
      </Box>

      {showDetails && (
        <Stack
          mt={0.5}
          sx={{
            wordSpacing: 1,
            lineHeight: "0.9rem",
            overflow: "scroll",
            scrollbarWidth: "none"
          }}
          onClick={(e) => { }}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            className="other-stack-adjust">
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <Avatar alt="Remy Sharp" src={file?.userProfilePicture} />
              <Typography>{file?.userName}</Typography>
            </Stack>
            <Typography>{moment(file?.dateCreated).format("MMMM DD, YYYY")}</Typography>
          </Stack>
          <Typography maxHeight={"100px"} overflow={"scroll"} variant="body2" mt={1}>
            {file?.description}
          </Typography>
        </Stack>
      )}
    </Box>
  );
}

export default PdfViewer;
